import axios from "axios";
import { clearStorage, getToken, saveToken } from "../../utils/localStorage";
import { REST_API_URL } from "../config";
import { authEndpoints } from "./authEndpoints";
import { smartAxios } from "../axios/Axios";

export const postRefreshToken = async () => {
  try {
    const refreshToken = getToken("refreshToken");
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }
    const response = await axios.post(
      authEndpoints.refreshToken,
      {
        refresh: refreshToken,
      },
      {
        baseURL: REST_API_URL,
      },
    );
    const accessToken = response?.data?.access;
    if (!accessToken) {
      throw new Error("Refresh token response does not contain access token");
    }
    saveToken("access", accessToken);
    return accessToken;
  } catch (error) {
    clearStorage();
    throw error;
  }
};

export const getUserEmail = () => {
    return smartAxios.get(authEndpoints.getUserEmail)
}

 

 
 
 

 

 
